import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { totalStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsTotal";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

totalStyles.orderTotal = mergeToNew(totalStyles.orderTotal, {
    totalLabel: {
        weight: fontWeights.regular,
    },
    totalValue: {
        weight: fontWeights.semiBold,
    },
    taxValue: {
        weight: fontWeights.semiBold,
    },
    taxLabel: {
        weight: fontWeights.regular,
    },
    subtotalLabel: {
        weight: fontWeights.regular,
    },
    subtotalValue: {
        weight: fontWeights.semiBold,
    },
    discountsLabel: {
        weight: fontWeights.regular,
    },
    discountsValue: {
        weight: fontWeights.semiBold,
    },
    shippingAndHandlingLabel: {
        weight: fontWeights.regular,
    },
    shippingAndHandlingValue: {
        weight: fontWeights.semiBold,
    },
    otherChargesLabel: {
        weight: fontWeights.regular,
    },
    otherChargesValue: {
        weight: fontWeights.semiBold,
    },
    container: {
        css: css`
            @media print {
                background: transparent;
                padding: 0; 
            }
        `
    }
});
